/** Diagnóstico local: somente campos do contrato de pedido mínimo, sem tokens/PII. */
export function logMinimumOrderResponse(
  context: { clientId?: string; method: string; endpoint: string; httpStatus: number },
  body: unknown,
): void {
  const endpoint = context.endpoint.split("?")[0];
  const credit = endpoint === "user/credit-limit";
  const checkout = /^checkout\/(carts|resume|orders|edit-order|remake-order)(\/|$)/.test(endpoint);
  if (!credit && !checkout) return;
  const envelope = body as any;
  const data = envelope?.data;
  const summary = data?.minimumOrderSummary;
  const impact = endpoint.endsWith("/cancel-impact") || envelope?.code === "MINIMUM_ORDER_IMPACT";
  const minimum = credit ? data?.minOrderAmount : impact ? data?.minimumOrder : summary?.minimumOrder;
  // Não inventar o mínimo a partir do faltante: a base pode excluir frete/descontos.
  const record = {
    timestamp: new Date().toISOString(),
    ...context,
    endpoint,
    currency: "BRL",
    unit: "centavos",
    source: credit ? "minOrderAmount" : impact ? "cancelImpact.minimumOrder" : summary ? "minimumOrderSummary.minimumOrder" : "legacy_remaining_only",
    minimumOrder: minimum ?? null,
    minimumOrderBRL: minimum != null && Number.isFinite(Number(minimum)) ? (Number(minimum) / 100).toFixed(2) : null,
    remainingMinimumOrder: data?.remainingMinimumOrder ?? null,
    enabled: (impact ? data?.enabled : summary?.enabled) ?? null,
    available: (impact ? data?.available : summary?.available) ?? null,
    deliveryDate: (impact ? data?.deliveryDate : summary?.deliveryDate) ?? null,
    currentTotal: summary?.currentTotal ?? null,
    accumulatedTotal: summary?.accumulatedTotal ?? null,
    combinedTotal: summary?.combinedTotal ?? null,
    remaining: summary?.remaining ?? null,
    satisfied: summary?.satisfied ?? null,
    reason: summary?.reason ?? null,
    isRedeemable: (summary?.isRedeemable ?? data?.isRedeemable) ?? null,
    hasRedeemOrder: (summary?.hasRedeemOrder ?? (impact ? data?.hasRedeemOrder : undefined)) ?? null,
    impacts: impact ? data?.impacts ?? null : null,
    remainingTotal: impact ? data?.remainingTotal ?? null : null,
    shortfall: impact ? data?.shortfall ?? null : null,
    code: envelope?.code ?? null,
  };
  // String serializada preserva o snapshot exato; DevTools não mostra objeto alterado depois.
  console.info("[PEDIDO_MINIMO]", JSON.stringify(record));
}
